import { render, staticRenderFns } from "./DoctorRegisterModal.vue?vue&type=template&id=18f0f672&"
import script from "./DoctorRegisterModal.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorRegisterModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports